module.exports = __webpack_public_path__ + "static/media/service_intelligence.3a9665e9.png";